export default class Board {
  id: string
  name: string
  userIdList: string[] = []
  shouldShow = "false"
  constructor (id: string, displayName: string) {
    this.id = id
    this.name = displayName
  }

  addUserId = (userId: string) => {
    this.userIdList.push(userId)
  }

  removeUserId = (userId: string) => {
    const index = this.userIdList.indexOf(userId)
    this.userIdList.splice(index, 1)
  }
}
